// 引入 axios
import axios from "axios";
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['token']='abcdefghijklmnopqrstuvwxyz'

// let base = 'http://localhost:8087';
let base = 'https://qixin.bhgmarketplace.com/api/portal/'

//传送json格式的get请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${url}`,
        data: params
    })
}
